<ng-container *ngIf="!loadingFormDetails; else loading">
    <div class="form">
        <h2 mat-dialog-title>{{ currentCultureFormName }}</h2>
        
        <mat-dialog-content>
            <app-form-generator 
                [formId]="formId"
                [formData]="formData"
                [emitFormDataTrigger]="getFormData"
                [targetEmployeeTablePermissions]="targetEmployeeTablePermissions"
                (emitFormData)="formDataEmitted($event)"
                (emitFormPristine)="formPristineEmitted($event)"
                (emitFormStatus)="formStatusUpdated($event)"
            ></app-form-generator>
        </mat-dialog-content>
        
        <mat-dialog-actions>
            <!-- Explains why Save is unavailable (WCAG 3.3.2) -->
            <span class="form-instructions" id="form-dialog-instructions" *ngIf="formValid === false">
                {{ 'CompleteRequiredFields' | translate: {Default: "Fill in the required fields marked * to save"} }}
            </span>
            <button mat-raised-button appPreventDoubleClick (throttledClick)="close()">{{ 'Close' | translate: {Default: "Close"} }}</button>
            
            <button 
                *appTableAccess="[tableUpdateAccessObj]" 
                mat-raised-button 
                setColor="primaryColour" 
                color="primary" 
                [disabled]="formValid === false" 
                [attr.aria-describedby]="formValid === false ? 'form-dialog-instructions' : null"
                appPreventDoubleClick 
                (throttledClick)="getFormData = !getFormData">
                {{ 'Save' | translate: {Default: "Save"} }}
            </button> 
        </mat-dialog-actions>
    </div>
</ng-container>

<ng-template #loading>
    <mat-dialog-content class="loading">
        <ngx-skeleton-loader
        count="5"
        [theme]="{ 
            'height.px': 50
        }"
        ></ngx-skeleton-loader>
    </mat-dialog-content>
</ng-template>